import { FC } from "react";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { NoUpcomingMeetingsContentView } from "./no-upcoming-meetings-content.view";

interface NoUpcomingMeetingsContentProps {
  cutoffDayName: string;
  connectedCalendarsCount: number;
}

export const NoUpcomingMeetingsContent: FC<NoUpcomingMeetingsContentProps> = observer(
  ({ cutoffDayName, connectedCalendarsCount }) => {
    const { store } = useAppStore();

    const handleClick = () => {
      store.navigation.goToIntegrationsCalendar({});
    };

    return (
      <NoUpcomingMeetingsContentView
        cutoffDayName={cutoffDayName}
        connectedCalendarsCount={connectedCalendarsCount}
        onClick={handleClick}
      />
    );
  }
);
